import { notificationStatus } from 'constants/notificationStatus'
import {
    BackLineProgress,
    ContainerNav,
    CurrentProgressStyle,
    GridProgressLine,
    Mt8px,
    NavProgressLine,
    NavProgressLineText
} from './styles'
import { useEffect, useState, useMemo } from 'react'
import { NotificationReducer } from 'types/notification'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'
import { getDateTime } from 'utils/damage'
import React from 'react'
import NotificationActions from 'actions/Notification'
import { calculateObjectProbabilityOcurrence } from 'pages/NotificationTreatment/helpers'
import { useParams } from 'react-router-dom'
import { isFinishedStatus } from '../NotificationTreatment'


interface NotificationTreatmentProps {
    currentStepSelected: number
    setCurrentStepSelected: React.Dispatch<React.SetStateAction<number>>
    notificationStatusState: string
    finishedSteps: isFinishedStatus[]
    isGroupTreatment?: boolean
}

export const currentStepSelectedTreatmentArray = ({
    isArchived,
    date,
    isGroupTreatment
}: {
    isArchived?: boolean
    date?: string
    isGroupTreatment?: boolean
}) => {
    if (isGroupTreatment) {
        let itens = [
            'Dados da notificação',
            'Análise de Ishikawa',
            'Protocolo de Londres',
            'Matriz de responsabilização',
            'Plano de ação',
            ...(isArchived ? [`Arquivada em ${getDateTime(date)}`] : ['Finalizar notificação'])
        ]
        return itens
    }

    let itens = [
        'Dados da notificação',
        'Análise de Ishikawa',
        'Protocolo de Londres',
        'Matriz de responsabilização',
        'Plano de ação',
        ...(isArchived ? [`Arquivada em ${getDateTime(date)}`] : ['Finalizar notificação'])
    ]

    return itens
}


/**
 * Componete qu representa a barra superior de tratamento da notificação.
 * Esse compoente redenriza as abas relacionadas a Dados da notificação, `Análise de Ishikawa`, 
 * `Protocolo de Londres`, `Matriz de responsabilização`, `Plano de ação` e `Finalizar notificação`
 * @param param0 
 * @returns 
 */
const NotificationTreatmentProgressBarNav: React.FC<
    NotificationTreatmentProps
> = ({ currentStepSelected, setCurrentStepSelected, notificationStatusState, finishedSteps, isGroupTreatment = false }) => {
    function handleChangeStep(clickedStep: number, currentStep: number) {

        let notification = notificationSelector.notificationById
        let notificationProcessRequiredStepsRules = calculateObjectProbabilityOcurrence(notification)
        if (notificationProcessRequiredStepsRules)
            notificationProcessRequiredStepsRules.currentStepSelected = currentStep
        NotificationActions.defineObjectNotificationProcessRequiredStepsRules(notificationDispatch, notificationProcessRequiredStepsRules)

        NotificationActions.setProgressBarNavClicked(notificationDispatch, true)
        if (notificationStatusState === notificationStatus[5].label) {
            return
        }
        setCurrentStepSelected(clickedStep + 1)
    }
    const notificationSelector: NotificationReducer = useSelector(
        (state: RootReducerState) => state.notificationsReducer
    )
    const { id } = useParams()
    const [colSize, setColSize] = useState<number>(6)

    const notificationDispatch = useDispatch()
    useEffect(() => {
        const allElements = document.querySelectorAll('[data-testid="test-notification-nav-item"]');
        const blockElements = Array.from(allElements).filter((element) => {
            return window.getComputedStyle(element).display === 'block';
        });
        setColSize(blockElements.length)
    }, [finishedSteps])

    const londonProtocol = useMemo(() => notificationSelector?.londonProtocol, [notificationSelector?.londonProtocol])
    const ishikawa = useMemo(() => notificationSelector.ishikawaDiagram, [notificationSelector.ishikawaDiagram])
    const actionPlans = useMemo(() => notificationSelector.actionPlans, [notificationSelector.actionPlans])
    const accountabilityMatrixMemo = useMemo(() => {
        if (notificationSelector?.accountabilityMatrix) {
            return notificationSelector?.accountabilityMatrix[0]
        }
    }, [notificationSelector?.accountabilityMatrix])

    const currentStep = (index: number) => {
        if (index === currentStepSelected - 1) return true
    }

    const isArchived = useMemo(() => {
        return notificationStatusState === notificationStatus[5].label
    }, [notificationStatusState])

    const progressLineStyles = ({ index }) => {
        if (currentStep(index)) {
            return 'bg-yellow';
        }

        if (isArchived && index === 0) {
            return 'bg-yellow';
        }

        if (isArchived) {
            return 'bg-mediumGray/60';
        }

        if (!isArchived) {
            const notification = notificationSelector?.notificationById;
            const formValid =
                notification?.u_image_risk?.value === 'u_image_risk_yes' ||
                notification?.u_oms_classification ||
                notification?.u_reclassified_incident_type;
            
            if (isGroupTreatment) {
                // For group treatment: 6 steps (Dados, Ishikawa, Londres, Matriz, Plano, Finalizar)
                switch (index) {
                    case 0:
                        // Para grupos, "Dados da notificação" sempre está verde pois as notificações já existem
                        return 'bg-active';
                    case 1:
                        let causes = ishikawa?.categories
                            .map((category) => category?.causes)
                            .map((itens) => itens?.toString())
                            .filter((i) => i?.length)
                        const hasFillingIshikawaDiagram = ishikawa?.sys_id && (ishikawa?.do_not_perform_optional === 'true' || causes?.length > 0);
                        return hasFillingIshikawaDiagram ? 'bg-active' : '';
                    case 2:
                        const hasFillingLondonProtocol =
                            (londonProtocol?.sys_id && !!londonProtocol?.date_of_patient_admission) ||
                            londonProtocol?.do_not_perform_optional === 'true'
                        return hasFillingLondonProtocol ? 'bg-active' : '';
                    case 3:
                        const hasFillingAccountabilityMatrix =
                            accountabilityMatrixMemo?.u_do_not_perform_optional === 'true' ||
                            accountabilityMatrixMemo?.u_matrix_result
                        return hasFillingAccountabilityMatrix ? 'bg-active' : '';
                    case 4:
                        // Para grupos, verificar AMBOS actionPlans (individual da primeira notificação) e actionPlansGroup
                        const individualActionPlans = actionPlans;
                        const actionPlansGroup = notificationSelector?.actionPlansGroup;
                        const hasIndividualPlans = individualActionPlans && individualActionPlans[0]?.sys_id && (individualActionPlans[0]?.u_do_not_perform_optional == 'true' || individualActionPlans[0]?.what != "");
                        const hasGroupPlans = actionPlansGroup && actionPlansGroup[0]?.sys_id && (actionPlansGroup[0]?.u_do_not_perform_optional == 'true' || actionPlansGroup[0]?.what != "");
                        return hasIndividualPlans || hasGroupPlans ? 'bg-active' : '';
                    case 5:
                        return (notificationStatusState === notificationStatus[4].label || notificationStatusState === notificationStatus[5].label) ? 'bg-active' : '';
                    default:
                        return '';
                }
            } else {
                // For individual treatment: 6 steps (original logic)
                switch (index) {
                    case 0:
                        return notificationStatusState === notificationStatus[0]?.label || formValid ? 'bg-active' : '';
                    case 1:
                        let causes = ishikawa?.categories
                            .map((category) => category?.causes)
                            .map((itens) => itens?.toString())
                            .filter((i) => i?.length)
                        const hasFillingIshikawaDiagram = ishikawa?.sys_id && (ishikawa?.do_not_perform_optional === 'true' || causes?.length > 0);
                        return hasFillingIshikawaDiagram ? 'bg-active' : '';
                    case 2:
                        const hasFillingLondonProtocol = (londonProtocol?.sys_id && !!londonProtocol?.date_of_patient_admission) || londonProtocol?.do_not_perform_optional === 'true';
                        return hasFillingLondonProtocol ? 'bg-active' : '';
                    case 3:
                        const hasFillingAccountabilityMatrix = accountabilityMatrixMemo?.u_do_not_perform_optional === 'true' || accountabilityMatrixMemo?.u_matrix_result
                        return hasFillingAccountabilityMatrix ? 'bg-active' : '';
                    case 4:
                        return actionPlans && actionPlans[0]?.sys_id && (actionPlans[0]?.u_do_not_perform_optional == 'true' || actionPlans[0]?.what != "") ? 'bg-active' : '';
                    case 5:
                        return notificationStatusState === notificationStatus[4].label ? 'bg-active' : '';
                    default:
                        return '';
                }
            }
        }

        return '';
    };
    return (
        <div>
            <ContainerNav className='relative' data-testid="test-notification-treatment-nav">
                {notificationStatusState === notificationStatus[1].label ||
                    notificationStatusState === notificationStatus[0].label ? (
                    <GridProgressLine>
                        <BackLineProgress />
                        <NavProgressLine
                            onClick={() => { }}>
                            <CurrentProgressStyle
                                data-testid="test-notification-nav-progress"
                                className={`bg-yellow ${!isArchived && 'group-hover:bg-mediumGray/60'}`} />
                            <Mt8px />
                            <NavProgressLineText>
                                {currentStepSelectedTreatmentArray({ 
                                    isArchived, 
                                    date: notificationSelector?.notificationById?.u_date_and_hour_notification_closed?.value,
                                    isGroupTreatment 
                                })[0]}

                            </NavProgressLineText>
                        </NavProgressLine>
                    </GridProgressLine>
                ) : (
                    <GridProgressLine id='grid-progress-line' className={`grid-cols-${colSize}`}>
                        {currentStepSelectedTreatmentArray({
                            isArchived,
                            date: notificationSelector?.notificationById?.u_date_and_hour_notification_closed?.value,
                            isGroupTreatment
                        }).map((item, index) => {
                            const isRequired = finishedSteps.find(f => f.label === item)?.isRequired
                            const isOptional = finishedSteps.find(f => f.label === item)?.isOptional
                            const isOlder = finishedSteps.find(f => f.label === item)?.isOlder
                            const currentStep = finishedSteps.find(f => f.label === item)?.currentStepTreatment
                            return (<React.Fragment key={index} >
                                <BackLineProgress />
                                <NavProgressLine style={{ display: isOlder || isRequired || isOptional || item === `Dados da notificação` ? 'block' : 'none' }}
                                    data-testid="test-notification-nav-item"
                                    onClick={() => handleChangeStep(index, currentStep)}>
                                    <CurrentProgressStyle
                                        data-testid="test-notification-nav-progress"
                                        className={`${progressLineStyles({ index }) || 'border border-grayBorder'} ${!isArchived && 'group-hover:bg-mediumGray/60'}`} />

                                    <Mt8px />
                                    <NavProgressLineText>
                                        <span>
                                            {item}
                                        </span>
                                        <span className='text-[#C43B51] w-[13px] h[13px]'>
                                            {isRequired ? "*" : ""}
                                        </span>
                                    </NavProgressLineText>
                                </NavProgressLine>
                            </React.Fragment>)
                        })}
                    </GridProgressLine>
                )}
            </ContainerNav >
        </div>
    )
}

export { NotificationTreatmentProgressBarNav }
